module.exports = __webpack_public_path__ + "assets/bar-chart-1.b2bb86c2.svg";